// dashboard/frontend/src/components/Campaign/channels/email/emailUtils.js

import api from '../../../../api/axios';

/**
 * Email-specific utility functions
 * These handle Gmail accounts, attachments, and email-specific filtering
 */

export const fetchGmailAccounts = async (setGmailAccounts, setSnackbar) => {
    try {
        const response = await api.get('/gmail-accounts/');
        setGmailAccounts(response.data.results || response.data || []);
    } catch (error) {
        console.error('Error fetching Gmail accounts:', error);
        setGmailAccounts([]);
        if (setSnackbar) {
            setSnackbar({
                open: true,
                message: 'Failed to load Gmail accounts',
                severity: 'error'
            });
        }
    }
};

export const fetchAttachments = async (campaignId, roundId, setAttachments, setSnackbar) => {
    try {
        const response = await api.get(`/campaigns/${campaignId}/rounds/${roundId}/attachments/`);
        setAttachments(response.data);
    } catch (error) {
        console.error('Error fetching attachments:', error);
        setAttachments([]);
        if (setSnackbar) {
            setSnackbar({
                open: true,
                message: 'Failed to load attachments',
                severity: 'error'
            });
        }
    }
};

export const handleViewInGmail = async (campaignId, roundId, contactEmail, setSnackbar, fetchDrafts) => {
    try {
        const response = await api.get(`/campaigns/${campaignId}/get_or_create_gmail_draft/`, {
            params: { 
                contact_email: contactEmail,
                round_id: roundId 
            }
        });
        
        if (response.data.draft_url) {
            window.open(response.data.draft_url, '_blank');
        } else if (response.data.success) {
            if (fetchDrafts) await fetchDrafts();
            setSnackbar({ 
                open: true, 
                message: 'Gmail draft created successfully', 
                severity: 'success' 
            });
        }
    } catch (error) {
        console.error('Error creating Gmail draft:', error);
        setSnackbar({
            open: true,
            message: error.response?.data?.error || 'Failed to create Gmail draft',
            severity: 'error'
        });
    }
};

/**
 * Filter contacts for email display - shows only those with drafts
 * and respects showSent filter
 */
export const filterEmailContacts = (contacts, draftsMap, showSent) => {
    return contacts.filter(contact => {
        const draft = draftsMap[contact.id];
        return draft && (showSent || draft.status !== 'sent');
    });
};